var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"study",class:_vm.classObject,style:(_vm.styleObject),on:{"click":_vm.handleClick}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(" Unlock a Secret Achievement "),_c('br'),_c('br'),_vm._v(" (Double click to hide) ")])
}]

export { render, staticRenderFns }